module.exports = __webpack_public_path__ + "8a31a1fbb7972fe671e0de4973084d1a.pdf";